export const DATE_TYPE_OPTIONS = {
  jobs: [
    {
      key: "SUBMITTED_DATE",
      label: "Date Submitted",
      field: "requestSummary.submittedDate"
    },
    {
      key: "COMPLETED_DATE",
      label: "Date/Time Completed",
      field: "completedDate"
    },
    {
      key: "DUE_DATE",
      label: "Due Date",
      field: "dueDate"
    }
  ],
  requests: [
    {
      key: "SUBMITTED_DATE",
      label: "Date Submitted",
      field: "submittedDate"
    },
    {
      key: "COMPLETED_DATE",
      label: "Date/Time Completed",
      field: "rolledUpCompletedDate"
    },
    {
      key: "DUE_DATE",
      label: "Due Date",
      field: "rolledUpDate"
    }
  ]
};

